export { default as useMaterialsFilterCategories } from './useMaterialsFilterCategories';
